module.exports = __webpack_public_path__ + "img/index3.96b804fd.png";